module.exports = __webpack_public_path__ + "img/subscribe.27d193d5.png";